// extracted by mini-css-extract-plugin
module.exports = {"applePayButton":"style_applePayButton__a0MVH","darkMode":"style_darkMode__Cl68e","sdkApplePayButton":"style_sdkApplePayButton__DY5Ym"};